export function LiveProgramIcon(props: Readonly<React.SVGProps<SVGSVGElement>>): JSX.Element {
  return (
    <svg width='12' height='12' viewBox='0 0 12 12' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <g clipPath='url(#clip0_live_program_icon)'>
        <path
          d='M8.12133 2.87866C9.2929 4.05024 9.2929 5.94973 8.12133 7.1213M3.87867 7.1213C2.7071 5.94973 2.7071 4.05024 3.87867 2.87866M2.46434 8.53555C0.511723 6.58292 0.511723 3.4171 2.46434 1.46448M9.53563 1.46448C11.4883 3.4171 11.4883 6.58292 9.53563 8.53555M5.99999 6C6.55227 6 6.99999 5.55228 6.99999 5C6.99999 4.44772 6.55227 4 5.99999 4C5.4477 4 4.99999 4.44772 4.99999 5C4.99999 5.55228 5.4477 6 5.99999 6ZM5.99999 6V10.5'
          stroke='currentColor'
          strokeWidth='1.2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_live_program_icon'>
          <rect width='12' height='12' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}
